import { HTMLProps } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import clsx from 'classnames'
import { useAppearance } from '@/shared/utils'
import { IMassMediaPost } from '@/interfaces/media'
import { MediaAboutCard } from '@/entities/media-about-card'
import style from './media-about-list.module.scss'

type MediaAboutListProps = HTMLProps<HTMLDivElement> & {
  cards: IMassMediaPost[]
}

export const MediaAboutList = (props: MediaAboutListProps) => {
  const { cards } = props
  const { ref: cardsRef, animate: cardsAnimate } = useAppearance()

  return (
    <motion.ul ref={cardsRef} animate={cardsAnimate} className={style.list}>
      <AnimatePresence mode="popLayout">
        {cards?.map(({ date_published, title, image_preview, url, excerpt, source }, index) => (
          <MediaAboutCard
            className={clsx(style.item)}
            key={index}
            title={title}
            excerpt={excerpt}
            source={source}
            date={date_published}
            image={image_preview}
            url={url}
          />
        ))}
      </AnimatePresence>
    </motion.ul>
  )
}
